import useNodesProjectStore from '../stores/useNodesProjectStore';
import useNodesUiStore from '../stores/useNodesUiStore';
import useNodesFeedStore from '../stores/useNodesFeedStore';

export function useNodesFeedUiSelectors() {
  const feedPage = useNodesFeedStore((s) => s.feedPage);
  const reloadingProducts = useNodesFeedStore((s) => s.reloadingProducts);
  const designTemplates = useNodesProjectStore((s) => s.designTemplates);
  const isTemplatesSideBarOpen = useNodesUiStore((s) => s.isTemplatesSideBarOpen);
  const isDataPreviewSideBarOpen = useNodesUiStore((s) => s.isDataPreviewSideBarOpen);
  const isAsideItemLoading = useNodesUiStore((s) => s.isAsideItemLoading);
  const product = useNodesFeedStore((s) => s.product);
  const productIndex = useNodesFeedStore((s) => s.productIndex);
  const feedPageIndex = useNodesFeedStore((s) => s.feedPageIndex);
  const productFields = useNodesFeedStore((s) => s.productFields);
  const feedSearchEmptyResult = useNodesFeedStore((s) => s.feedSearchEmptyResult);
  const run = useNodesProjectStore((s) => s.run);
  const loadFeed = useNodesFeedStore((s) => s.loadFeed);
  const showTemplatesSideBar = useNodesUiStore((s) => s.showTemplatesSideBar);
  const showDataPreviewSideBar = useNodesUiStore((s) => s.showDataPreviewSideBar);
  const deleteDesignTemplate = useNodesProjectStore((s) => s.deleteDesignTemplate);
  const toNextProduct = useNodesFeedStore((s) => s.toNextProduct);
  const toPrevProduct = useNodesFeedStore((s) => s.toPrevProduct);
  const toSelectProduct = useNodesFeedStore((s) => s.toSelectProduct);
  const toFeedPageSelect = useNodesFeedStore((s) => s.toFeedPageSelect);
  const searchProductById = useNodesFeedStore((s) => s.searchProductById);
  const setProduct = useNodesFeedStore((s) => s.setProduct);
  const setProductIndex = useNodesFeedStore((s) => s.setProductIndex);

  return {
    feedPage,
    reloadingProducts,
    designTemplates,
    isTemplatesSideBarOpen,
    isDataPreviewSideBarOpen,
    isAsideItemLoading,
    product,
    productIndex,
    feedPageIndex,
    productFields,
    feedSearchEmptyResult,
    run,
    loadFeed,
    showTemplatesSideBar,
    showDataPreviewSideBar,
    deleteDesignTemplate,
    toNextProduct,
    toPrevProduct,
    toSelectProduct,
    toFeedPageSelect,
    searchProductById,
    setProduct,
    setProductIndex,
  };
}
